import A from 'components/atoms/A/A';
import Button from 'components/atoms/Button/Button';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import SurveyCardStatic from 'components/molecules/SurveyCard/SurveyCardStatic.qmee';
import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import OinqMoneyHappy from './assets/oinq-money-happy.svg';
import classes from './PublicSurveys.qmee.module.scss';
import { useStaticSurveys } from './useStaticSurveys';
import { SIGN_UP } from 'components/pages/pages';
import { useNamespace } from 'components/templates/Translation/TranslationWrapper';

export interface Props {}

const PublicSurveys: React.FC<Props> = () => {
  const router = useRouter();
  const namespace = useNamespace();
  const { t } = useTranslation([namespace, 'earn-money-online']);
  const staticSurveys = useStaticSurveys();

  const ctaText = staticSurveys.filter((survey) => survey.id === 'static-prescreener')[0]?.title;

  // Show consistent title
  const formatSurveys = staticSurveys.filter((survey) => survey.id !== 'static-prescreener');

  const handleSignUp = () => {
    router.push(SIGN_UP.path);
  };

  return (
    <div className={classes.root}>
      <Card className={classes.ctaCard}>
        <div className={classes.oinqImageContainer}>
          <OinqMoneyHappy className={classes.oinqMoneyHappy} />
        </div>
        <div className={classes.content}>
          <Txt className={classes.text} skipTranslation>
            {ctaText ? t(ctaText, { ns: 'earn-money-online' }) : ''}
          </Txt>
          <Button
            buttonType="primary"
            className={classes.startEarningButton}
            onClick={handleSignUp}
          >
            <Txt>Start Earning</Txt>
          </Button>
        </div>
      </Card>

      <div className={classes.bannerContainer}>
        {formatSurveys.map((survey) => (
          <Card key={survey.id} className={classes.cardRoot}>
            <A href={'/#'} className={classes.innerLink}>
              <SurveyCardStatic
                className={classes.surveyCard}
                surveyId={survey.id}
                duration={survey.duration}
                title={survey.title}
                tags={survey.tags}
                amount={
                  typeof survey.reward === 'object' && survey.reward !== null
                    ? survey.reward.cents / 100
                    : 0
                }
                currency={
                  typeof survey.reward === 'object' && survey.reward !== null
                    ? survey.reward.currency
                    : 'USD'
                }
              />
            </A>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PublicSurveys;
